<template>
    <div class="chart-block" style="min-height:297px">
        <h3>   <a :href="url" target="_blank"> {{chartName}}</a>


              <el-tooltip class="item" effect="dark" content="新四化指数" placement="bottom">
        <svg-icon name="faq" size="20" @click.native="faq()" color="#53b1e7"></svg-icon>
      </el-tooltip>
             <span>{{updated}}</span>
        </h3>
        <div id="chart_xsqs" class="chart-box">
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    export default {
        props: {
            chartName: {
                type: String,
                default: '整体市场销售趋势'
            }
        },
        data() {
            return {
                url:"#",
                chartOption: {},
                updated:'',
            }
        },
        mounted() {
          
            let myChart = echarts.init(document.getElementById('chart_xsqs'));
            this.chartOption = {
                color: ['#4ebdea', '#a7def3', '#327ed4', '#8369e8'],
                title: {
                    text: '整体市场销售趋势',
                    show: false
                },
                grid: {
                    left: '5%',
                    right: '5%',
                    bottom: '11%',
                    top: '15%',
                    containLabel: true
                },
                tooltip: {
                    // trigger: 'axis',
                    showDelay: 0,
                    formatter: function(params) {
                        if (params.value.length > 1) {
                            return params.seriesName + ' :<br/>' +
                                params.value[0] + '增长率 ' +
                                params.value[1] + '增长率 ';
                        } else {
                            return params.seriesName + ' :<br/>' +
                                params.name + ' : ' +
                                params.value + '增长率 ';
                        }
                    },
                    axisPointer: {
                        show: true,
                        type: 'cross',
                        lineStyle: {
                            type: 'dashed',
                            width: 1
                        },
                        axisLabel: {
                            color: '#ccc'
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitArea: {
                            show: false
                        },
                    }
                },
                toolbox: {
                    show: false,
                },
                brush: {},
                legend: {
                    data: ['销售增长率', '市场占有率'],
                    left: 'center'
                },
                xAxis: [{
                        scale: true,
                        interval: 50,
                        axisLabel: {
                            color: '#ccc',
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitArea: {
                            show: false
                        },
                    }, { //用于显示区域名称
                        name: '个性化产品',
                        nameTextStyle: {
                            color: '#3b5b81'
                        },
                        type: 'value',
                        nameGap: -80,
                        offset: -20,
                        nameLocation: 'end',
                        axisLine: {
                            show: false
                        }
                    }, { //用于显示区域名称
                        name: '成熟性产品',
                        nameTextStyle: {
                            color: '#3b5b81'
                        },
                        type: 'value',
                        nameGap: -75,
                        offset: -20,
                        position: 'bottom',
                        nameLocation: 'end',
                        axisLine: {
                            show: false
                        }
                    },
                    { //用于显示区域名称
                        name: '标准化产品',
                        type: 'value',
                        nameGap: -90,
                        offset: -20,
                        position: 'bottom',
                        nameTextStyle: {
                            color: '#3b5b81'
                        },
                        nameLocation: 'start',
                        axisLine: {
                            show: false
                        }
                    },
                    { //用于显示区域名称
                        name: '创新类产品',
                        type: 'value',
                        nameGap: -80,
                        offset: -20,
                        position: 'top',
                        nameLocation: 'start',
                        nameTextStyle: {
                            color: '#3b5b81'
                        },
                        axisLine: {
                            show: false
                        }
                    }, {
                        name: '市场占有率',
                        type: 'value',
                        scale: true,
                        position: 'bottom',
                        nameTextStyle: {
                            color: '#47bae7',
                            padding: [0, 0, -35, -60] // 四个数字分别为上右下左与原位置距离
                        },
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitArea: {
                            show: false
                        },
                    }
                ],
                yAxis: [{
                        scale: true,
                        interval: 8,
                        axisLabel: {
                            color: '#ccc',
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitArea: {
                            show: false
                        },
                    },
                    {
                        name: '销售增长率',
                         
                        offset: -20,
                        nameTextStyle: {
                            color: '#47bae7'
                        },
                        min: 18,
                        type: 'value',
                        scale: false,
                        axisLabel: {
                            show: false,
                        },
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        }
                    }
                ],
                series: [{
                    name:'整体市场销售趋势',
                    type: 'effectScatter',
                    symbolSize: 12,
                    color:'#f36070',
                    data: [
                        [1292, 66.4],
                        [1100, 47.6]
                    ]
                }, {
                    type: 'scatter',
                    name:'整体市场销售趋势',
                    data: [
                          [700, 51.6],
                        [980, 40.0],
                        [700, 49.2],
                        [600, 63.0],
                        [821, 53.6],
                        [999, 59.0],
                        [1000, 47.6],
                        [876, 69.8],
                        [981, 66.8],
                        [1161, 65.2],
                        [492, 66.4],
                          [876, 80]
                    ],
                    markPoint: {
                         symbol: 'pin',
                        data: [{
                                type: 'average',
                                name: '这是一个标记',
                                value:[500,60]
                            },
                            {
                                type: 'min',
                                name: '最小值'
                            }
                        ]
                    },
                    markLine: {
                        symbol: 'none',
                        lineStyle: {
                            normal: {
                                type: 'solid',
                                color: '#327ed4'
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                            },
                        },
                        data: [{
                                type: 'average',
                                name: '平均值'
                            },
                            {
                                type: 'average',
                                name: '平均值',
                                xAxis: 900
                            }
                        ]
                    }
                }]
            };
            myChart.setOption(this.chartOption);
            //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
            window.addEventListener('resize', function() {
                myChart.resize()
            });
        },
        methods: {},
        watch: {},
        created() {}
    }
</script>
 <<style scoped>
    #chart_xsqs {
        min-height: 250px;
        width: 100%;
    }
</style>